<template>
    <div>
        <Modal v-model="modalShow" title="未成年人模式" class-name="vertical-center-modal my-modal"
            @on-cancel="close" :mask-closable="false" width="400" :footer-hide="true">
            <div class="tc">
                <div style="display: flex; justify-content: space-between; align-items: center;width:80%; margin:0 auto;">
                    <div class="img-item" style="padding-top:5px;">
                        <img src="../../assets/img/live/01.png" style="display: inline;width:40px;height:40px;"/>
                        <p style="margin-top:5px;">消费限制</p>
                    </div>
                    <div class="img-item">
                        <img src="../../assets/img/live/02.png" style="display: inline;width:45px;height:45px;"/>
                        <p style="margin-top:5px;">内容精选</p>
                    </div>
                    <div class="img-item">
                        <img src="../../assets/img/live/03.png" style="display: inline;width:45px;height:45px;"/>
                        <p style="margin-top:5px;">时长控制</p>
                    </div>
                </div>
            </div>
            <div class="tc" style="margin:15px 0;">
                <span style="color:#27b110;">未成年人模式已开启</span>
            </div>
            <div class="tc">
                <ButtonGroup shape="circle">
                    <Button type="warning" @click="showNext" style="width:230px;">退出未成年人模式</Button>
                </ButtonGroup>
            </div>
        </Modal>
        <!-- 设置密码 -->
        <setD ref="setDRef"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import setD from './setD.vue'; //设置密码
export default {
    name: "setC",
    components: {
        setD
    },
    data() {
        return {
            modalShow: false,
        };
    },
    computed: {
        ...mapState(['user', 'isLogin', 'wcnCfg']),
    },
    mounted() {
    },
    methods: {
        showNext(){
            this.$refs.setDRef.show();
            this.modalShow = false;
        },
        //显示弹窗
        show() {
            this.modalShow = true;
        },
        //关闭弹窗
        close() {
            this.modalShow = false;
        }
    }
};
</script>

<style lang="scss">
.my-modal .ivu-modal-header {
    border-bottom: 0px solid #e8eaec;
    padding: 14px 16px 0 16px;
}
</style>
<style lang="scss" scoped>
.tc{
    text-align: center;
}
.cu{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/wcn/setC.vue